import { EventBus } from "../../../eventbus";
import { thumbnail, placeholderThumb } from "../../../functions/thumbnail";
import VueCircle from "vue2-circle-progress";

export default {
  props: {
    item: Object,
  },
  components: { VueCircle },
  data() {
    return {
      itemData: null,
      timeout: 8000,
    };
  },
  created() {
    if (this.item) {
      this.itemData = this.item;

      this.setup();

      EventBus.$on(`snackbar-item--update`, (data) => {
        if (data.id === this.itemData.id) {
          //update this item
          this.itemData = { ...this.itemData, ...data };

          this.updateProgress();
        }
      });
    }
  },
  methods: {
    updateProgress() {
      if (this.itemData.progress && this.$refs.progressCircle) {
        this.$refs.progressCircle.updateProgress(this.itemData.progress);
      }
    },
    setup() {
      if (!this.itemData.btns && !this.itemData.noTimer) {
        //activate timer
        this.removeTimer();
      }
    },
    onSwipe(e) {
      if (itemData.canClose === undefined || itemData.canClose) {
        EventBus.$emit(`snackbar--remove`, this.itemData.id);
      }
    },
    removeTimer() {
      setTimeout(
        () => {
          EventBus.$emit(`snackbar--remove`, this.itemData.id);
        },
        this.itemData.timeout ? this.itemData.timeout : this.timeout
      );
    },
    handleRemoveItem($event) {
      $event.preventDefault();

      EventBus.$emit(`snackbar--remove`, this.item.id);
    },
    thumb(item, big = false, defaultVal = false) {
      return thumbnail(item, big, defaultVal);
    },
    onError() {
      return placeholderThumb();
    },
  },
};
